import { Type } from 'class-transformer';
import { Event } from './event';
import { Task } from './task';
import { Model } from './model';

export class TaskTrigger extends Model {
  id: string;

  @Type(() => Event)
  event: Event;

  @Type(() => Task)
  task: Task;

  message: string;

  entity: object;

  data: object;

  entity_id: string;

  name: string;

  actor_id: string | null;

  api_request_id: string | null;
}
